import { render } from "./BankList.vue?vue&type=template&id=b1c65948&scoped=true"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"

import "./BankList.vue?vue&type=style&index=0&id=b1c65948&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c65948"]])

export default __exports__